export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  TAG_PAGE: "tag-page",
  SEARCH_PAGE: "search-page",
  GETAPP_PAGE: "getapp-page",
  AUTHOR_PAGE: "author-page",
  STORY_PAGE: "story-page",
  CATALOG_PAGE: "catalog-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  STORY_PREVIEW: "story-preview",
  HOME_PREVIEW: "home-preview",
  STATIC_PAGE: "static-page",
  CORPORATE_CORNER: "corporate-corner"
});
export const TAG_PAGE_URL_PREFIX = "/topic/";

export const storyFields =
  "alternative,sections,headline,cards,subheadline,author-name,author-id,authors,updated-at,last-published-at,published-at,first-published-at,metadata,hero-image-metadata,hero-image-s3-key,slug,id,seo,story-template";
